import { apiCall } from "@/common/api/ApiResult.model";
import axios from "axios";

export type OrgImpersonateStatus = "None" | "Requested" | "Open";

export const get_impersonation_status = apiCall<void, OrgImpersonateStatus>(
  "support.get_impersonation_status",
  async () => {
    const res = await axios.get("/backoffice/access");
    return {
      success: true,
      value: res.data.status,
    };
  }
);

export const approve_impersonation = apiCall<void, boolean>(
  "support.approve_impersonation",
  async () => {
    await axios.post("/backoffice/access/approve");
    return {
      success: true,
      value: true,
    };
  }
);

export const reject_impersonation = apiCall<void, boolean>(
  "support.approve_impersonation",
  async () => {
    await axios.post("/backoffice/access/reject");
    return {
      success: true,
      value: true,
    };
  }
);

export const revoke_impersonation = apiCall<void, boolean>(
  "support.revoke_impersonation",
  async () => {
    await axios.post("/backoffice/access/revoke");
    return {
      success: true,
      value: true,
    };
  }
);

export const provide_impersonation = apiCall<void, boolean>(
  "support.provide_impersonation",
  async () => {
    await axios.post("/backoffice/access/provide");
    return {
      success: true,
      value: true,
    };
  }
);
